// NPM Imports
import React from 'react'
import useFeaturePermissions from '../../../hooks/useFeaturePermissions'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
// Asset Imports

// Bootstrap Imports
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'

export default function NotesRow() {
   const state = useQuoteContext()
   const { getString } = state
   const { featurePermissions, hasPermission } = useFeaturePermissions()
   const editNotes = hasPermission('EditNotes', state.user_role)
   const notesSection = hasPermission('NotesSection', state.user_role)

   if (!notesSection || state.user_view !== 'Internal') {
      return null
   }

   return (
      <InputGroup className='mt-2'>
         <InputGroup.Text>{getString('product.NotesRow.Text')}</InputGroup.Text>
         {/* <Form.Text muted>Enter any comments for this quote here. Input is limited to 500 characters.</Form.Text> */}
         <Form.Control
            as='textarea'
            rows={3}
            className='form-control form-control-bhr2 me-5'
            maxLength={1024}
            value={state.quoteNotes}
            readOnly={!editNotes}
            disabled={!editNotes}
            onChange={(e) => {
               if (editNotes) {
                  state.setQuoteNotes(e.target.value)
               }
            }}
         ></Form.Control>
      </InputGroup>
   )
}
